import {xml2json} from 'xml-js';

function convertXmlToJson(xml) {
  const parsedJSON = xml2json(xml, {compact: true, spaces: 4});
  return parsedJSON;
}


export const transcriptionUtils = {
  methods: {
    convertXmlToJson
  }
}
